import {enableProdMode, ApplicationRef} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from '@app/app.module';
import {environment} from '@environments/environment';

//
// SyncFusion License
//
import {registerLicense} from '@syncfusion/ej2-base';
import {enableDebugTools} from '@angular/platform-browser';

registerLicense('ORg4AjUWIQA/Gnt2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRd0VhX35WcHxUT2RfWUE=');

if (environment.production) {
  enableProdMode();
}

// const bootstrap = () => platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .then(moduleRef => {
//     const applicationRef = moduleRef.injector.get(ApplicationRef);
//     const appRef = applicationRef.components[0];
//     enableDebugTools(appRef);
//   })
//   .catch(err => console.error(err));
//
// bootstrap()
//   .catch((err) => {
//     console.log('[main.ts] bootstrap().catch');
//     console.error(err);
//   });

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(moduleRef => {
    // enableDebugTools(moduleRef.injector.get(ApplicationRef).components[0]);
  })
  .catch(err => console.error(err));

// https://github.com/juggle/resize-observer/blob/master/README.md#resize-loop-detection
window.addEventListener('error', (e) => {
  // console.log('[main.ts] addEventListener');
  // console.log(e.message);
  // console.log(e);
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    return false;
  }
});
